import { render, staticRenderFns } from "./eventInfo.vue?vue&type=template&id=423d5b6a&scoped=true&"
import script from "./eventInfo.vue?vue&type=script&lang=js&"
export * from "./eventInfo.vue?vue&type=script&lang=js&"
import style0 from "./eventInfo.vue?vue&type=style&index=0&id=423d5b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d5b6a",
  null
  
)

export default component.exports